export default function () {
    return {
        selectedReceiptLog: {},
    };
}
